(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('ControllerPaymentCustomService',ControllerPaymentCustomService);

    ControllerPaymentCustomService.$inject = ['$http'];

    function ControllerPaymentCustomService($http) {
        var service = {
            findAllControllerPaymentsByControllerId: findAllControllerPaymentsByControllerId
        };

        return service;

        function findAllControllerPaymentsByControllerId(id) {
            var url = "api/controller-payment/controller/" + id;
            return $http.get(url);
        }
    }
})();
